import { ImageManager } from './ImageManager';

const defaultImagesMap = {
  IMAGE_01:
    'https://versatil-salescloud.relevantsolutions.com.br/images/ffddc3db-3aae-4d73-ac9c-e1263641f7b4-03c89c34-49a4-4d45-b289-4d2261158cbe.png',
  IMAGE_02:
    'https://versatil-salescloud.relevantsolutions.com.br/images/acbae5eb-efa4-4eb6-866c-f421e740b713-ad3c92b1-9cdb-4a7b-aad3-75ad809db8a3.png',
  IMAGE_03:
    'https://versatil-salescloud.relevantsolutions.com.br/images/98520d6c-5cef-449e-bcbf-6316ccec2088-e8780361-0deb-4896-895e-e690c886cdf0.png',
  IMAGE_04:
    'https://versatil-salescloud.relevantsolutions.com.br/images/b064f705-34ba-4400-975e-9dd0cec21c30-cc9aa158-56bd-4bf1-b532-72390d25c864.png',
  IMAGE_59:
    'https://versatil-salescloud.relevantsolutions.com.br/images/8e0e07e2-3f84-4426-84c1-2add355c558b-image.png',
  IMAGE_09:
    'https://versatil-salescloud.relevantsolutions.com.br/images/be34fb18-32ad-441c-84d8-3c0e9ba9f742-ad2ea5ff-5d0b-446b-bd7d-8e2ab5afdd16.png',
  IMAGE_10:
    'https://versatil-salescloud.relevantsolutions.com.br/images/6a1e6292-469e-452a-bbae-44e4b5ff7463-05e543b6-c951-44ce-ae27-ca1282c77f52.png',
  IMAGE_15:
    'https://versatil-salescloud.relevantsolutions.com.br/images/f69f48af-5b15-40aa-91c4-81d601d1357b-083dc99d-02a6-40d9-ae28-0662bd078b5d.png',
  IMAGE_16:
    'https://versatil-salescloud.relevantsolutions.com.br/images/9cce6b16-5a98-4ddb-b1a1-6cec2cf56891-c3acb856-8ab8-4cfb-93f9-2a0747678b8b.png',
  IMAGE_17:
    'https://versatil-salescloud.relevantsolutions.com.br/images/d9795c1d-fa32-4adb-ab25-30b7cfe87936-df21314f-6f05-4550-80b3-9ab1107e8fbe.png',
  IMAGE_31:
    'https://versatil-salescloud.relevantsolutions.com.br/images/dd1584fb-cb60-42c9-80c7-5545e16130ca-226ba72b-ce9e-4948-ad0d-347381fb96c5.png',
};

ImageManager.add(defaultImagesMap);
export function getImg(name: keyof typeof defaultImagesMap) {
  return ImageManager.get(name);
}
